export default function formatCountry(country_initials) {
  if (country_initials !== "br") {
    return "Internacional";
  }
  return "Brasil";
}
